/**
 * Displays business-office notes for an expanded sibling order.
 */

import type { BusniessOfficeNote } from "../../data-model/busniessOfficeNote";
import { renderTextWithProperIndentation } from "../../pages/singleOrderLayout/components/busniessOffice/components/singleComment/utils/renderTextWithProperIndentation";

/** Props for {@link ExpnadableBusniessOfficeNotesForSiblings}. */
interface ExpnadableBusniessOfficeNotesForSiblingsProps {
  /** Business-office notes to render for the expanded sibling order. */
  notes: BusniessOfficeNote[];
}

/**
 * Renders each sibling-order business-office note with its date and content.
 *
 * @param props - Notes associated with the expanded sibling order.
 * @returns The business-office note list.
 */
const ExpnadableBusniessOfficeNotesForSiblings = ({
  notes,
}: ExpnadableBusniessOfficeNotesForSiblingsProps) => {
  return (
    <div className="expandable-row-notes-content--container flex gap-4 p-4">
      <div className="no-content ml-2 border-r-1 border-primaryGray-15">
        &nbsp;
      </div>
      <div className="notes--container rounded-notes-table flex w-full flex-col gap-3 rounded-md bg-drugTableBg p-3">
        {notes.map((note, index) => {
          const noteDate = note.visit_date ?? note.visit_date_text ?? "N/A";
          const noteContent = note.template_text ?? "N/A";

          return (
            <div
              key={note.report_identifier ?? `${noteDate}-${index}`}
              className="notes--entry flex flex-col gap-2"
            >
              <div className="notes--header text-overline font-bold">
                DOS: {noteDate}
              </div>
              <div className="notes--body overflow-x-hidden rounded-lg border border-primaryGray-14 bg-white p-3 text-overline font-normal">
                {renderTextWithProperIndentation(noteContent)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExpnadableBusniessOfficeNotesForSiblings;
